// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/app-" + (chunkId === 980 ? "html2pdf" : chunkId) + ".min.js";
};